<template>
  <AppSection
    id="emails"
    type="section"
    :title="$getConst.pages.scope_emails.emails_page_title"
    :is-section-loading="isLoading"
  >

    <b-row>

      <b-col sm="6">
        <b-form-group  id="it-helpdesk" :label="$t($getConst.pages.scope_emails.it_helpdesk_label) + ' *'" label-for="it-helpdesk-input">
          <b-form-input
            id="it-helpdesk-input"
            :disabled="hasWritePermission"
            v-model.trim="$v.emailsToEdit.it_helpdesk.$model"
            :class="{ 'is-invalid': $v.emailsToEdit.it_helpdesk.$error }"
            :placeholder="$t($getConst.pages.scope_emails.it_helpdesk_placeholder) + ' *'"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.emailsToEdit.it_helpdesk"/>
        </b-form-group>
      </b-col>

      <b-col sm="6">
        <b-form-group  id="admin-email" :label="$t($getConst.pages.scope_emails.admin_email_label) + ' *'" label-for="admin-email-input">
          <b-form-input
            id="admin-email-input"
            :disabled="hasWritePermission"
            v-model.trim="$v.emailsToEdit.admin_email.$model"
            :class="{ 'is-invalid': $v.emailsToEdit.admin_email.$error }"
            :placeholder="$t($getConst.pages.scope_emails.admin_email_placeholder) + ' *'"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.emailsToEdit.admin_email"/>
        </b-form-group>
      </b-col>


      <b-col sm="6">
        <b-form-group  id="cci_test" :label="$t($getConst.pages.scope_emails.test_email_label) + ' *'" label-for="cci-input">
          <b-form-input
            id="cci-input"
            :disabled="hasWritePermission"
            v-model.trim="$v.emailsToEdit.test_email.$model"
            :class="{ 'is-invalid': $v.emailsToEdit.test_email.$error }"
            :placeholder="$t($getConst.pages.scope_emails.test_email_placeholder) + ' *'"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.emailsToEdit.test_email"/>
        </b-form-group>
      </b-col>

      <b-col sm="6">
        <b-form-group  id="cci"  label-for="cci-input" label-class="mb-0">
          <template #label>
            <label>{{$t($getConst.pages.scope_emails.cci_label) + ' *'}}</label>
            <b-form-checkbox
              id="is_cci"
              class="d-inline float-right"
              switch
              size="lg"
              v-model="$v.emailsToEdit.is_cci.$model"
            ></b-form-checkbox>
          </template>
          <b-form-input
            id="cci-input"
            :disabled="hasWritePermission || !emailsToEdit.is_cci"
            v-model.trim="$v.emailsToEdit.cci.$model"
            :class="{ 'is-invalid': $v.emailsToEdit.cci.$error, 'd-none': !emailsToEdit.is_cci}"
            :placeholder="$t($getConst.pages.scope_emails.cci_placeholder) + ' *'"
            size="lg"
            required
          ></b-form-input>
          <AppFormFeedback :errors="$v.emailsToEdit.cci"/>
        </b-form-group>
      </b-col>

    </b-row>

    <b-row>
      <b-col cols="6" class="checkbox">
        <b-form-checkbox class="d-inline" switch v-model="$v.emailsToEdit.enable_email.$model" size="lg">
        </b-form-checkbox>
        <label>
          {{$t($getConst.pages.scope.enable_email)}}
        </label>
      </b-col>
    </b-row>

    <AppConfirmButtons
      v-if="!hasWritePermission"
      @onSubmit="onSubmit"
      @onCancel="onCancel"
    />


  </AppSection>
</template>

<script>
  import {required, email} from "vuelidate/lib/validators";
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";
  import AppFormFeedback from "../../../../components/common/form/AppFormFeedback";
  import {getScopeEmails, updateScopeEmails} from "../../../../api/scopeEmails.api";
  import requiredIf from "vuelidate/lib/validators/requiredIf";

  export default {
    name: "index",
    components: {AppFormFeedback, AppConfirmButtons, AppSection},
    props: {
      scope_id: null
    },
    data() {
      return {
        emails: null,
        isLoading: false,
        emailsToEdit: {
          it_helpdesk: null,
          admin_email: null,
          cci: null,
          is_cci: false,
          test_email:null,
          enable_email: false
        },
        hasWritePermission: !this.hasAnyOfPermissions(
          [this.$getConst.permissions.writeScopeEmails, this.$getConst.permissions.writeScope]
        )
      }
    },
    validations: {
      emailsToEdit: {
        it_helpdesk: {required, email},
        admin_email: {required, email},
        cci: {required: requiredIf(function() {return this.emailsToEdit.is_cci}),email},
        is_cci: {required},
        test_email: {required, email},
        enable_email: {required},
      }
    },
    methods: {
      getEmails() {
        this.isLoading = true;
        getScopeEmails(this.scope_id).then(
          (response) => {
            this.emails = Object.assign({}, response.data);
            this.emailsToEdit = response.data;
            this.isLoading = false;
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      },
      isFormInvalid() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isSubmited = false;
          return true;
        }
        return false
      },
      onSubmit() {
        if (this.isFormInvalid()) {
          return;
        }
        this.isLoading = true;
        updateScopeEmails(this.scope_id, this.emailsToEdit).then(
          (response) => {
            this.emails = Object.assign({}, response.data);
            this.isLoading = false;
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      },
      onCancel() {
        this.emailsToEdit = Object.assign({}, this.emails);
      },
    },
    created() {
      this.getEmails();
    }
  }
</script>

<style scoped>

</style>
